import { ValuePair } from './valuepair';


export class ActivityModel{
    public id:string;
    public name:string;
    public description:string;
    public values:ValuePair[] = [];

}